// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-pivot-table';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.576 8.784h7.488M6.192 12.96H2.088c-.864 0-1.512-.648-1.512-1.512v-9.36c0-.864.648-1.512 1.512-1.512H13.32c.864 0 1.512.648 1.512 1.512V5.76M.576 4.68h14.256m-8.928 0v5.04m4.536-5.04v1.728m2.376 6.696a2.243 2.243 0 0 0 2.232-2.232V7.92' />
    <path d='M16.776 9.576 15.12 7.848l-1.728 1.728m-4.968 3.528h4.392a2.243 2.243 0 0 0 2.232-2.232' />
    <path d='m10.152 11.376-1.728 1.728 1.728 1.656' />
  </g>
);

export const viewBox = '0 0 18 18';
